import { Header } from '../header/header'
import { styles } from './page-container.styles'

export interface PageContainerProps {
  children: React.ReactNode
  type?: 'authenticated' | 'unauthenticated'
  title?: string
  footer?: React.ReactNode
  footerClass?: string
}

export const PageContainer: React.FC<PageContainerProps> = ({
  children,
  type,
  title,
  footer,
  footerClass
}) => {
  return (
    <div className={styles.outerContainer}>
      <div className={styles.innerContainer}>
        <Header type={type} />
        {title && (
          <div className={`${styles.titleSection}`}>
            <p className={`${styles.titleText} text-center text-xs`}>{title}</p>
          </div>
        )}
        <div className={styles.contentContainer}>{children}</div>
        {footer && <footer className={`${styles.footer} ${footerClass}`}>{footer}</footer>}
      </div>
    </div>
  )
}
